import { Button, Card, Col, Form, Input, Row, Select } from 'antd'
import React from 'react'
import Heading from '../../../component/common/Heading'
import useHttp from '../../../hooks/use-http';
import CONSTANTS from '../../../util/constant/CONSTANTS';

const Notification = () => {
    const [form] = Form.useForm();
    const api = useHttp()

    const submitHandler = (value) => {
        // console.log(value);
        const NOTIFICATION_API = { ...CONSTANTS.API.Notification.sentNotification }
        api.sendRequest(NOTIFICATION_API, () => {
            form.resetFields()
        }, value, 'Notification Sent Successfully!!!')
    }

    return (
        <>
            <Card className="my-5">
                <Heading>
                    General Notification
                </Heading>
                <Form className='my-5' onFinish={submitHandler} form={form}>

                    <Row>
                        <Col span={4}>
                            <p className="text-xl mt-1">
                                Notification Title
                            </p></Col>
                        <Col span={8}>
                            <Form.Item name='title' id="title"  >
                                <Input type="text" placeholder='Enter a  Notification  Title' />

                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={4}>
                            <p className="text-xl mt-1">
                                Message
                            </p></Col>
                        <Col span={8}>
                            <Form.Item name='body' id="body"  >
                                <Input type="text" placeholder='Enter a Message' />

                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={4}>
                            <p className="text-xl mt-1">
                                Click Action
                            </p></Col>
                        <Col span={8}>
                            <Form.Item name='clickAction' id="clickAction"  >
                                <Select placeholder='Select a Click Action'>
                                    <Select.Option value="Home">Home</Select.Option>
                                    <Select.Option value="Profile">Profile</Select.Option>
                                    <Select.Option value="Subscription">Subscription</Select.Option>
                                    <Select.Option value="Feedback">Feedback</Select.Option>
                                    <Select.Option value="Blog">Blog</Select.Option>

                                </Select>

                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item

                    >
                        <Button className='mt-2' type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>

            </Card>
        </>
    )
}

export default Notification